import React from 'react';
import { Grid } from '@material-ui/core';
import { Skeleton } from 'fpay-ui';

function Loader() {
  return (
    <Grid container>
      <Grid item container justify="center">
        <Skeleton
          style={{
            width: '114px',
            height: '114px',
            borderRadius: '50%',
            margin: 'auto',
            marginTop: '83px',
          }}
        />
      </Grid>
      <Grid item container justify="center">
        <Skeleton
          style={{
            width: '79px',
            height: '31px',
            borderRadius: '4px',
            marginTop: '25px',
            marginBottom: '10px',
          }}
        />
      </Grid>
      <Grid item container justify="center">
        <Skeleton
          style={{ width: '350px', height: '31px', borderRadius: '4px', marginBottom: '35px' }}
        />
      </Grid>
      <Grid item container justify="center">
        <Skeleton type="title" style={{ marginTop: '-19px', marginBottom: '32px' }} />
      </Grid>
      <Grid item container justify="center">
        <Skeleton style={{ width: '150px', height: '40pxpx', borderRadius: '4px' }} />
      </Grid>
    </Grid>
  );
}

export default Loader;
